import React from 'react';
import { Link } from 'react-router-dom';

export default function ShelflineTerms() {
  return (
    <div className="min-h-screen bg-zinc-950 text-white">
      {/* Navigation */}
      <nav className="fixed top-0 w-full bg-zinc-950/80 backdrop-blur-md border-b border-zinc-800/50 z-50">
        <div className="max-w-4xl mx-auto px-6 py-4 flex justify-between items-center">
          <Link to="/" className="text-lg font-mono text-zinc-400 hover:text-white transition-colors">
            ← Back to Portfolio
          </Link>
        </div>
      </nav>

      {/* Content */}
      <main className="pt-24 pb-20 px-6">
        <div className="max-w-4xl mx-auto">
          <div className="mb-12">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">Terms of Use</h1>
            <p className="text-zinc-400 text-lg">Shelfline - Board Game Collection & Play Tracker</p>
            <p className="text-zinc-500 text-sm mt-2">Last updated: July 14, 2026</p>
          </div>

          <div className="space-y-10 text-zinc-300 leading-relaxed">
            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">Agreement</h2>
              <p>
                By downloading or using Shelfline ("the App"), you agree to these Terms of Use.
                If you do not agree, please do not use the App. The App is purchased through the
                Apple App Store or Google Play, and your purchase is also subject to the terms of
                those stores.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">License</h2>
              <p>
                We grant you a personal, non-exclusive, non-transferable license to use the App on
                devices you own or control, for your personal, non-commercial use. You may not
                copy, modify, distribute, sell, or reverse-engineer the App except where permitted
                by law.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">Your Data</h2>
              <p>
                All content you create in the App (your collection, plays, players, notes, and
                photos) belongs to you and is stored on your device. You are responsible for
                backing it up using the App's export feature. Deleting the App deletes its local
                data, and we have no way to recover it for you.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">Game Data &amp; Trademarks</h2>
              <p>
                The App includes a catalog of factual information about published board games
                (titles, player counts, playtimes, and similar details). All board game titles are
                trademarks of their respective publishers. Shelfline is an independent app and is
                not affiliated with, endorsed by, or sponsored by any board game publisher or by
                BoardGameGeek. Game cover images shown in the App are original generated artwork,
                not publisher box art.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">Barcode Lookups</h2>
              <p>
                Barcode identification relies in part on third-party product databases. We do not
                guarantee that any particular barcode will be recognized, and results from
                third-party databases may occasionally be inaccurate. The App always lets you
                identify a game manually.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">Disclaimer of Warranties</h2>
              <p>
                The App is provided "as is" and "as available," without warranties of any kind,
                express or implied, including fitness for a particular purpose and
                non-infringement. We do not warrant that the App will be uninterrupted or
                error-free.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">Limitation of Liability</h2>
              <p>
                To the maximum extent permitted by law, we shall not be liable for any indirect,
                incidental, special, consequential, or exemplary damages arising from your use of
                the App, including loss of data. Our total liability for any claim relating to the
                App is limited to the amount you paid for it.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">Changes</h2>
              <p>
                We may update the App and these Terms from time to time. Material changes will be
                reflected by revising the "Last updated" date above. Continued use of the App
                after changes constitutes acceptance of the updated Terms.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">Contact</h2>
              <p>
                Questions about these Terms? Contact us at{' '}
                <a
                  href="mailto:parkerdevwork@gmail.com"
                  className="text-emerald-400 hover:text-emerald-300 underline"
                >
                  parkerdevwork@gmail.com
                </a>.
              </p>
            </section>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="py-8 px-6 border-t border-zinc-800/50">
        <div className="max-w-4xl mx-auto text-center text-sm text-zinc-600">
          <p>© 2026 Shelfline. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}
